<template>
    <h4 class="mb-[10px] font-poppins font-medium text-[20px] text-[#F5B134]">Add Card</h4>
    <form @submit.prevent="submitForm" class="flex flex-col gap-[15px]">
        <div class="flex flex-col gap-[3px]">
            <label class="text-[14px] font-normal font-poppins text-[#666666] w-full" for="cardholder">Cardholder
                Name<span class="ml-1 text-red-500">*</span></label>
            <inputComponent ref="cardHolderName" name="cardholder" required placeholder="Full name on card" length="120"
                v-model="cardHolderName" error-message="Invalid Cardholder Name"
                @focus="handleFocus"
                customClass="!text-[16px] font-poppins font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]" />
        </div>
        <div class="flex flex-col gap-[3px]">
            <label class="text-[14px] font-normal font-poppins text-[#666666] w-full" for="cardnumber">Card
                Number<span class="ml-1 text-red-500">*</span></label>
            <div class="relative">
                <div id="card-number" class="min-h-[36px] tablet:min-h-[38px] mobile:py-[8px] tablet:py-[10px] px-3 rounded-[5px] border border-[#cccccc]">
                </div>
                <div id="card-number-error" class=""></div>
            </div>
        </div>
        <div class="grid tablet:grid-cols-2 mobile:gap-[15px] laptop:gap-[30px]">
            <div class="flex flex-col gap-[3px]">
                <label class="text-[14px] font-normal font-poppins text-[#666666] w-full" for="cardexpiry">Card
                    Expiry<span class="ml-1 text-red-500">*</span></label>
                <div class="relative">
                    <div id="card-expiry" class="min-h-[36px] tablet:min-h-[38px] mobile:py-[8px] tablet:py-[10px] px-3 rounded-[5px] border border-[#cccccc]">
                    </div>
                    <div id="card-expiry-error" class=""></div>
                </div>
            </div>
            <div class="flex flex-col gap-[3px]">
                <label class="text-[14px] font-normal font-poppins text-[#666666] w-full" for="cardCVC">Card CVC<span
                        class="ml-1 text-red-500">*</span></label>
                <div class="relative">
                    <div id="card-cvc" class="min-h-[36px] tablet:min-h-[38px] mobile:py-[8px] tablet:py-[10px] px-3 rounded-[5px] border border-[#cccccc]">
                    </div>
                    <div id="card-cvc-error" class=""></div>
                </div>
            </div>
        </div>
        <div class="flex desktop:items-center laptop:items-center mobile:items-start">
            <label class="flex items-center cursor-pointer mt-0">
                <input type="checkbox" v-model="checkbox" class="hidden peer" />
                <span
                    class="min-w-7 min-h-7 flex items-center justify-center border-[1px] !border-[#ccc] bg-[#fff] peer-checked:bg-[#2459A8] rounded-md transition">
                    <svg v-if="checkbox == true" class="w-6 h-6 text-[#fff]" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 20 20">
                        <path d="M5 10.5 8.5 14 15 7.5" />
                    </svg>
                </span>
                <span class="ml-2 text-[16px] font-normal text-[#666666] text-justify font-poppins leading-tight">Set as
                    Default</span>
            </label>
        </div>
    </form>
    <div class="flex justify-center mt-[30px]">
        <button :disabled="!validationCheck"
            class="px-[30px] py-[8px] text-[14px] tablet:text-[16px] font-poppins rounded-full transition duration-300 border-[1px] CustomBlueBtn disabled:hover:cursor-not-allowed disabled:hover:text-[#CCCCCC] disabled:bg-[#efefef] disabled:hover:!bg-[#efefef] disabled:hover:bg-none disabled:!text-[#CCCCCC] disabled:border-[#efefef]"
            @click="submitForm">Add Card</button>
    </div>
</template>
<script>
import { globals } from "../../main";
import inputComponent from '../partialComponent/inputComponent.vue';
import { useToast } from "vue-toastification";
const toast = useToast();
export default {

    components: {
        inputComponent
    },
    emits: ["submitDetail"],
    props: ["stripe_id"],
    data() {
        return {
            checkbox: false,
            selected: "credit",
            accountTitle: null,
            rountingNumber: null,
            accountType: null,
            accountNumber: null,
            checkboxes: {
                terms: false,
            },
            isValid: false,
            token: null,
            cardNumber: null,
            cardExpiry: null,
            cardCvc: null,
            cardHolderName: null,
            cardNumberError: null,
            cardExpiryError: null,
            cardCvcError: null,
            cardNumberValid: false,
            cardExpiryValid: false,
            cardCvcValid: false,
            cardBrand: null
        }
    },

    computed: {

        stripeElements() {
            return this.$stripe.elements({
                fonts: [
                    {
                        cssSrc: "https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap",
                    },
                ],
            });
        },

        validationCheck() {
            if (this.$helper.isEmpty(this.cardHolderName)) return false;
            if (!this.cardNumberValid) return false
            if (!this.cardExpiryValid) return false
            if (!this.cardCvcValid) return false
            // if (!this.checkboxes.terms) return false

            return true;
        },
    },

    watch: {
        'stripe_id': {

            handler(value) {
                if (this.stripe_id == null) {
                    setTimeout(() => {
                        this.create()
                    }, 50);
                }
            },
            immediate: true,
        },

    },

    mounted() {
    },

    methods: {
        reset() {
            // Reset field state FIRST
            if (this.$refs.cardHolderName) {
                this.$refs.cardHolderName.resetField()
            }
            
            this.isValid = false
            this.token = null
            this.cardHolderName = null
            this.cardNumberError = ''
            this.cardExpiryError = ''
            this.cardCvcError = ''
            this.cardNumberValid = false
            this.cardExpiryValid = false
            this.cardCvcValid = false
            this.cardBrand = ''
            this.checkboxes = {
                terms: false,
            }
            this.checkbox = false
            document.getElementById('card-number-error').innerHTML = ''
            document.getElementById('card-expiry-error').innerHTML = ''
            document.getElementById('card-cvc-error').innerHTML = ''
            this.destroy()
            this.create()

        },

        create() {
            // globals.$loader.show();
            const style = {
                base: {
                    color: 'black',
                    fontFamily: '"Lato", sans-serif',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#ccccd1',
                    },
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a',
                },
            };

            console.log("STRIP", this.$stripe)

            if (this.$stripe == null) {

                // this.$stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY, {
                //     stripeAccount: this.stripe_id + ""
                // })
                this.$stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY)

            }
            this.cardNumber = this.stripeElements.create('cardNumber', {
                style,
                disableLink: true,
            });

            this.cardNumber.mount('#card-number');
            this.cardExpiry = this.stripeElements.create('cardExpiry', { style });
            this.cardExpiry.mount('#card-expiry');
            this.cardCvc = this.stripeElements.create('cardCvc', { style });
            this.cardCvc.mount('#card-cvc');

            // Add focus listeners for smooth scrolling on mobile
            this.cardNumber.on('focus', () => this.handleFocus({ target: document.getElementById('card-number') }));
            this.cardExpiry.on('focus', () => this.handleFocus({ target: document.getElementById('card-expiry') }));
            this.cardCvc.on('focus', () => this.handleFocus({ target: document.getElementById('card-cvc') }));

            this.cardNumber.on("change", (event) => {

                // brand detect
                this.cardBrand = event.brand && event.brand !== "unknown"
                    ? (event.brand == 'visa' ? 'card-icon-1'
                        : event.brand == 'mastercard' ? 'card-icon-2'
                            : event.brand == 'amex' ? 'card-icon-3'
                                : null) : null;

                if (event.error) {
                    this.cardNumberValid = false
                    this.cardNumberError = event.error.message
                } else if (!event.complete) {
                    this.cardNumberValid = false
                    this.cardNumberError = "Card number is incomplete"
                } else {
                    this.cardNumberValid = true
                    this.cardNumberError = null
                }
                this.displayError(event, "card-number-error")
            })

            this.cardExpiry.on("change", (event) => {
                if (event.error) {
                    this.cardExpiryValid = false
                    this.cardExpiryError = event.error.message
                } else if (!event.complete) {
                    this.cardExpiryValid = false
                    this.cardExpiryError = "Card number is incomplete"
                } else {
                    this.cardExpiryValid = true
                    this.cardExpiryError = null
                }
                this.displayError(event, "card-expiry-error")
            })

            this.cardCvc.on("change", (event) => {
                if (event.error) {
                    this.cardCvcValid = false
                    this.cardCvcError = event.error.message
                } else if (!event.complete) {
                    this.cardCvcValid = false
                    this.cardCvcError = "Card number is incomplete"
                } else {
                    this.cardCvcValid = true
                    this.cardCvcError = null
                }
                this.displayError(event, "card-cvc-error")
            })

            // globals.$loader.hide();
        },

        displayError(event, elementId) {
            let errorContainer = document.getElementById(elementId);
            if (event.error) {

                errorContainer.innerHTML = `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">${event.error.message}</p>`
                if (elementId === "card-number-error") this.cardNumberError = event.error.message;
                if (elementId === "card-expiry-error") this.cardExpiryError = event.error.message;
                if (elementId === "card-cvc-error") this.cardCvcError = event.error.message;
            } else {
                errorContainer.innerHTML = ''
                if (elementId === "card-number-error") this.cardNumberError = null;
                if (elementId === "card-expiry-error") this.cardExpiryError = null;
                if (elementId === "card-cvc-error") this.cardCvcError = null;
            }
        },

        destroy() {

            if (this.cardNumber) {
                this.cardNumber.destroy();
            }

            if (this.cardExpiry) {
                this.cardExpiry.destroy();
            }

            if (this.cardCvc) {
                this.cardCvc.destroy();

            }
        },

        checkValidation() {
            let isValid = true;

            const refsToValidate = [
                this.$refs.cardHolderName,
            ];
            let firstInvalidRef = null;
            // Validate each ref
            for (const ref of refsToValidate) {
                if (ref?.validate?.()) {
                    if (!firstInvalidRef) firstInvalidRef = ref;
                }
            }
            // Cardholder Name
            if (firstInvalidRef) {
                isValid = false;
            }
            // Stripe elements errors
            if (this.cardNumberError) {
                document.getElementById('card-number-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">${this.cardNumberError}</p>`;
                isValid = false;
            }
            if (this.cardExpiryError) {
                document.getElementById('card-expiry-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">${this.cardExpiryError}</p>`;
                isValid = false;
            }
            if (this.cardCvcError) {
                document.getElementById('card-cvc-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">${this.cardCvcError}</p>`;
                isValid = false;
            }
            if (!this.cardNumberError && !this.cardNumber._complete) {
                document.getElementById('card-number-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">Card number field is required</p>`;
                isValid = false;
            }
            if (!this.cardExpiryError && !this.cardExpiry._complete) {
                document.getElementById('card-expiry-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">Expiry date field is required</p>`;
                isValid = false;
            }
            if (!this.cardCvcError && !this.cardCvc._complete) {
                document.getElementById('card-cvc-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">CVC field is required</p>`;
                isValid = false;
            }

            return isValid;
        },

        async getData() {
            const { token, error } = await this.$stripe.createToken(this.cardNumber)
            return { token, error }
        },

        async submitForm() {

            if (this.checkValidation()) {
                globals.$loader.show();
                let payload = await this.getData()
                if (payload.error) {
                    globals.$loader.hide();
                    toast.error(payload?.error?.message ?? 'Something went wrong.');
                    return
                }


                globals.$loader.hide();
                let formData = {
                    card_token: payload.token.id,
                    card_holder_name: this.cardHolderName,
                    is_default: this.checkbox ? '1' : '0'
                }
                this.$emit('submitDetail', formData);
            }
        },

        termsClicked() {

        },

        handleFocus(event) {
            if (window.innerWidth < 1024) { // Only for mobile/tablet
                const element = event.target || event.srcElement;
                if (element) {
                    setTimeout(() => {
                        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }, 300); // Delay for keyboard animation
                }
            }
        }

    },

}
</script>